import { render, staticRenderFns } from "./OffendingPrefixes.vue?vue&type=template&id=503f7e64&scoped=true&"
import script from "./OffendingPrefixes.vue?vue&type=script&lang=js&"
export * from "./OffendingPrefixes.vue?vue&type=script&lang=js&"
import style0 from "./OffendingPrefixes.vue?vue&type=style&index=0&id=503f7e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503f7e64",
  null
  
)

export default component.exports